(() => {
  if (window.pbAdaptiveHeader) return;
  window.pbAdaptiveHeader = true;
  let sequence = 0, timer, observer, first, header;
  const imageCache = new Map();
  const visible = el => {
    const r = el.getBoundingClientRect(), s = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && s.display !== 'none' && s.visibility !== 'hidden' && !el.closest('[hidden], [aria-hidden="true"]');
  };
  const rgb = c => `rgb(${c.map(Math.round).join(' ')})`;
  const parse = value => {
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = 1;
    const ctx = canvas.getContext('2d', {willReadFrequently:true});
    ctx.fillStyle = value;
    ctx.fillRect(0,0,1,1);
    return [...ctx.getImageData(0,0,1,1).data];
  };
  const luminance = c => c.slice(0,3).map(v => {v /= 255; return v <= .04045 ? v / 12.92 : ((v + .055) / 1.055) ** 2.4;}).reduce((a,v,i) => a + v * [.2126,.7152,.0722][i],0);
  function apply(background, colors, mode) {
    const white = Math.min(...colors.map(c => 1.05 / (luminance(c) + .05)));
    const dark = Math.min(...colors.map(c => (luminance(c) + .05) / .05));
    let text = white >= dark ? '255 255 255' : '0 0 0';
    if (Math.max(white,dark) < 4.5) {
      const mean = colors.reduce((a,c) => a.map((v,i)=>v+c[i]/colors.length),[0,0,0]);
      background = rgb(mean);
      text = luminance(mean) > .179 ? '0 0 0' : '255 255 255';
    }
    header.style.setProperty('--pb-header-surface',background);
    header.style.setProperty('--pb-header-ink',text);
    header.dataset.pbAdaptive = mode;
  }
  function backgroundOf(el) {
    for (let node = el; node; node = node.parentElement) {
      const s = getComputedStyle(node), c = parse(s.backgroundColor);
      if (s.backgroundImage.includes('gradient(') && !s.backgroundImage.includes('url(')) {
        const colors = s.backgroundImage.match(/rgba?\([^)]+\)/g)?.map(parse).filter(c=>c[3]===255);
        if (colors?.length) return {background:s.backgroundImage,colors,mode:'gradient'};
      }
      if (c[3] === 255) return {background:s.backgroundColor,colors:[c],mode:'color'};
    }
    return null;
  }
  async function sampleImage(el,url) {
    let task = imageCache.get(url);
    if (!task) {
      task = new Promise((resolve,reject)=>{
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.onload = ()=>resolve(image);
        image.onerror = reject;
        image.src = url;
      });
      imageCache.set(url,task);
      if (imageCache.size > 12) imageCache.delete(imageCache.keys().next().value);
    }
    const image = await task;
    const r=el.getBoundingClientRect(),s=getComputedStyle(el),nw=image.naturalWidth,nh=image.naturalHeight;
    const isImg=el.tagName==='IMG',fit=isImg?s.objectFit:s.backgroundSize;
    const scale = fit==='contain'?Math.min(r.width/nw,r.height/nh):Math.max(r.width/nw,r.height/nh);
    let sw=nw,sh=nh,sy=0,sx=0;
    if (fit==='cover'||fit==='contain') {
      const pos=(isImg?s.objectPosition:s.backgroundPosition).split(' ');
      const fraction=(v)=>v?.endsWith('%')?parseFloat(v)/100:.5;
      const ox=(r.width-nw*scale)*fraction(pos[0]),oy=(r.height-nh*scale)*fraction(pos[1]);
      if (oy > 1 || ox > 1) throw new Error('Image does not cover the boundary');
      sx=Math.max(0,-ox/scale);sy=Math.max(0,-oy/scale);sw=Math.min(nw-sx,r.width/scale);sh=Math.min(nh-sy,Math.max(1,8/scale));
    } else sh=Math.max(1,nh*Math.min(8/r.height,.04));
    const canvas=document.createElement('canvas');canvas.width=60;canvas.height=4;
    const ctx=canvas.getContext('2d',{willReadFrequently:true});ctx.drawImage(image,sx,sy,sw,sh,0,0,60,4);
    const data=ctx.getImageData(0,0,60,4).data,colors=[];
    const base=backgroundOf(el)?.colors[0]||[255,255,255];
    for(let segment=0;segment<3;segment++){
      const channels=[[],[],[]];
      for(let y=0;y<4;y++)for(let x=segment*20;x<(segment+1)*20;x++){
        const i=(y*60+x)*4,a=data[i+3]/255;
        channels.forEach((c,k)=>c.push(data[i+k]*a+base[k]*(1-a)));
      }
      colors.push(channels.map(c=>c.sort((a,b)=>a-b)[Math.floor(c.length/2)]));
    }
    const media=el.closest('.content-over-media');
    if(media){
      const overlay=getComputedStyle(media).getPropertyValue('--content-over-media-overlay').trim();
      if(overlay){const c=parse(`rgb(${overlay})`),a=c[3]/255;colors.forEach(row=>row.forEach((v,i)=>row[i]=v*(1-a)+c[i]*a));}
    }
    return {background:`linear-gradient(90deg, ${colors.map(rgb).join(', ')})`,colors,mode:'image'};
  }
  async function update() {
    const current=++sequence;
    header=document.querySelector('store-header');
    const main=document.querySelector('#main');
    if(!header||!main)return;
    const section=[...main.children].find(el=>el.matches('.shopify-section')&&visible(el));
    if(!section)return;
    if(first!==section){
      first=section;observer?.disconnect();
      observer=new MutationObserver(schedule);
      observer.observe(first,{subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset','class','hidden','aria-hidden']});
    }
    if(!header.dataset.pbDefaultInk){
      const s=getComputedStyle(header);
      header.dataset.pbDefaultInk=s.getPropertyValue('--header-text').trim();
      header.style.setProperty('--pb-menu-ink',header.dataset.pbDefaultInk);
      header.style.setProperty('--pb-menu-surface',s.getPropertyValue('--header-background').trim());
    }
    const override=section.querySelector('[data-pb-header-background]')||section;
    if(override.dataset.pbHeaderBackground==='off'){delete header.dataset.pbAdaptive;return;}
    if(override.dataset.pbHeaderBackground){
      const value=override.dataset.pbHeaderBackground;
      if(CSS.supports('color',value)){apply(value,[parse(value)],'override');return;}
    }
    const top=section.getBoundingClientRect().top;
    const nodes=[section,...section.querySelectorAll('div,section,image-banner,img,video')].filter(visible);
    const surface=nodes.filter(el=>{const r=el.getBoundingClientRect();return r.width>=innerWidth*.88&&Math.abs(r.top-top)<24&&r.height>30;});
    const candidates=surface.filter(el=>el.tagName==='IMG'||getComputedStyle(el).backgroundImage.startsWith('url('));
    const image=candidates.find(el=>el.tagName==='IMG')||candidates[0];
    const bg=backgroundOf(surface.at(-1)||section);
    if(bg)apply(bg.background,bg.colors,bg.mode);else delete header.dataset.pbAdaptive;
    if(image){
      const url=image.tagName==='IMG'?(image.currentSrc||image.src):getComputedStyle(image).backgroundImage.match(/^url\(["']?(.*?)["']?\)$/)?.[1];
      if(url)try{const sampled=await sampleImage(image,url);if(current===sequence&&header.isConnected)apply(sampled.background,sampled.colors,sampled.mode);}catch{}
    }
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(update,120);}
  addEventListener('resize',schedule,{passive:true});
  document.addEventListener('load',e=>{if(e.target.tagName==='IMG'&&first?.contains(e.target))schedule();},true);
  ['shopify:section:load','shopify:section:reorder','shopify:section:unload','carousel:change','carousel:settle'].forEach(name=>document.addEventListener(name,schedule));
  addEventListener('pageshow',schedule);
  update();
})();
